import * as t from "react";
var e = /* @__PURE__ */ t.createContext(null);
export {
  e as default
};
//# sourceMappingURL=context.mjs.map
